import { ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import { ScrollbarSkins, scrollbar, BackgroundsDarkValues } from '@picsart/cascade';

const useStyles = createUseStyles({
  body: {
    gridArea: 'body',
    minWidth: 0,
    minHeight: 0,
    position: 'relative',
    transform: 'translate3d(0, 0, 0)',
  },
  bodyContent: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    height: '100%',
    overflow: 'hidden auto',
    ...scrollbar({
      skin: ScrollbarSkins.Control,
    }),
    '@media (hover: hover)': {
      '&::-webkit-scrollbar-thumb': {
        '&:hover': {
          background: BackgroundsDarkValues.tint6,
        }
      },
    },
  },
});

function Body({ children }: { children: ReactNode }) {
  const classes = useStyles();

  return (
    <div className={classes.body}>
      <div className={classes.bodyContent}>{children}</div>
    </div>
  );
}

export default Body;
